import { __decorate } from "tslib";
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { validationMixin } from 'vuelidate';
import DiyRouterLeaveGuard from '@/helpers/vue_mixins/v2/DiyRouterLeaveGuard';
import ActionButton from '@/components/action_button/Index.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import BaseTextArea from '@/components/v2/BaseTextArea';
import ButtonGenerator from '@/components/v3/prompts/ButtonGenerator.vue';
import PhoneInput from '@/components/v2/PhoneInput.vue';
import DiyMixin from '@/helpers/vue_mixins/v2/DiyMixin';
import FormHeader from '@/components/v2/FormHeader.vue';
import CategoryPicker from '@/components/v3/CategoryPicker.vue';
import FormHeaderMixin from '@/helpers/vue_mixins/v2/FormHeaderMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import OperatingLeadTimeMixin from '@/helpers/vue_mixins/v2/OperatingLeadTimeMixin';
import TheDiyActions from '@/components/v2/diy/TheDiyActions.vue';
import { Getter, Mutation } from 'vuex-class';
import { required, email, maxLength, minValue, requiredIf, numeric, } from 'vuelidate/lib/validators';
import { isEmpty } from 'lodash';
import { DIY } from '@/helpers/constants/Store';
import ConfirmationDialog from '@/components/ConfirmationDialog.vue';
import ToggleConfirmationDialog from '@/components/v2/ToggleConfirmationDialog.vue';
import ResetPersistentMenu from '@/plugins/graphql/mutations/page-reset-persistent-menu.gql';
import { successfulUpdate, invalidType, requiredProperty, } from '@/helpers/mixins/LocalizationHelper';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import CopyToClipboardMixin from '@/helpers/vue_mixins/v2/CopyToClipboardMixin';
import Uploader from '@/components/v2/Uploader';
import BaseImagePlaceholder from '@/components/v2/BaseImagePlacelholder';
import { selectOptionBuilder } from '@/helpers/select_option_builder';
import { CategoryTree } from '@/helpers/constants/CategoryTree';
import { ECOMMERCE_B2C, SHOPIFY } from '@/helpers/constants/Bundles';
import { MALL_MANAGEMENT } from '@/helpers/constants/CustomBundleKeys';
import { Bundle } from '@/helpers/entities/enums/v2/Bundle';
let PageSettingsForm = class PageSettingsForm extends Mixins(Mixins(validationMixin, DiyMixin, FormHeaderMixin, FormValidationsMixin, ViewportSizeMixin), AlertMixin, CopyToClipboardMixin, DiyRouterLeaveGuard, OperatingLeadTimeMixin) {
    constructor() {
        super(...arguments);
        this.userNameTag = '<<user_name>>';
        this.refNoTag = '<<reference_number>>';
        this.inputConfirmation = false;
        this.enableOperatingHours = false;
        this.enableLeadTime = false;
        this.leadTimeDays = 1;
        this.hours = [
            '12:00 AM',
            '1:00 AM',
            '2:00 AM',
            '3:00 AM',
            '4:00 AM',
            '5:00 AM',
            '6:00 AM',
            '7:00 AM',
            '8:00 AM',
            '9:00 AM',
            '10:00 AM',
            '11:00 AM',
            '12:00 PM',
            '1:00 PM',
            '2:00 PM',
            '3:00 PM',
            '4:00 PM',
            '5:00 PM',
            '6:00 PM',
            '7:00 PM',
            '8:00 PM',
            '9:00 PM',
            '10:00 PM',
            '11:00 PM',
        ];
        this.openingTime = '';
        this.closingTime = '';
        this.allowClosingHoursOrder = null;
        this.allowClosingHoursOrderOptions = [
            {
                text: 'Close Store',
                value: false,
                tooltipText: 'Stop accepting orders and display a message that the store is closed.',
            },
            {
                text: 'Accept Advanced Orders',
                value: true,
                tooltipText: 'Allow customers to place orders for a future date and time while the store is closed.',
            },
        ];
        this.form = {
            appUuid: null,
            appName: null,
            welcomeMessageUuid: null,
            welcomeMessageContent: null,
            welcomeButtonTitle: null,
            emailNotifRecipients: null,
            supportEmailList: null,
            supportContactNumber: null,
            pageUuid: null,
            greeting: null,
            categoryTree: this.baseCategories(),
            businessDescription: null,
            miniAppNotifications: [],
            generalAdsPostbackPayload: null,
            referralCode: null,
            shoulderConvenienceFee: false,
            shoulderProcessingFee: false,
            ageRequirement: null,
            shopNowPersistentMenuTitle: null,
            shopNowPersistentMenuUuid: null,
            welcomeImage: [],
            storeTitle: null,
            enableLeadTime: null,
            enableOperatingHours: null,
            leadTimeValue: null,
            openingHour: null,
            closingHour: null,
            allowClosingHoursOrder: null,
        };
        this.categoryOptions = CategoryTree;
        this.feePayload = {
            val: null,
            feeType: null,
        };
    }
    goToPagActivation() {
        this.allowNavigation();
        this.$router.push({
            name: 'connect-your-facebook',
            params: {
                serviceBundleUuid: this.$route.params.serviceBundleUuid,
                appUuid: this.$route.params.appUuid,
            },
        });
    }
    get persistentMenuTypes() {
        return [
            selectOptionBuilder('Shop Now 🛍', 'Shop Now 🛍'),
            selectOptionBuilder('Order Now 🛍', 'Order Now 🛍'),
        ];
    }
    get shoulderFeeTypes() {
        return [
            { value: true, text: `Enable` },
            { value: false, text: `Disable` },
        ];
    }
    get ageRequirementTypes() {
        return [
            { value: null, text: `Disabled` },
            { value: 18, text: `18+` },
            { value: 21, text: `21+` },
        ];
    }
    // private get cartMenuTypes(): SelectItem[] {
    //   return [
    //     selectOptionBuilder("Cart 🛒", "Cart 🛒"),
    //     selectOptionBuilder("Order History 🛒", "Order History 🛒"),
    //   ];
    // }
    get updatePromptActionInput() {
        // For failing test
        if (this.requiredGenerationFields.length > 0) {
            return {};
        }
        return {
            input: {
                appUuid: this.$route.params.appUUID || this.$route.params.appUuid,
                name: this.form.appName,
                primaryCategories: Object.keys(this.form.categoryTree).filter((key) => this.form.categoryTree[key].primaryOption),
                secondaryCategories: Object.keys(this.form.categoryTree)
                    .map((key) => this.form.categoryTree[key].secondaryOptions)
                    .flat(),
                businessDescription: this.form.businessDescription,
            },
        };
    }
    get requiredGenerationFields() {
        return [
            ...(this.$v.form.appName.$invalid ? ['store name'] : []),
            ...(this.$v.form.categoryTree.$invalid ? ['merchant category'] : []),
            ...(this.$v.form.businessDescription.$invalid ? ['company description'] : []),
        ];
    }
    baseCategories() {
        return Object.keys(CategoryTree)
            .map((category) => {
            const newobj = {
                [category]: {
                    primaryOption: false,
                    secondaryOptions: [],
                },
            };
            return newobj;
        })
            .reduce((a, v) => ({
            ...a,
            ...v,
        }), {});
    }
    onFormChanged(form) {
        this.updatePageGreeting(form.greeting || '');
    }
    get trailingWhitespace() {
        return (value) => {
            const hasTrailingWhitespace = value.trim() !== value;
            return hasTrailingWhitespace;
        };
    }
    getEmailErrors(emailList, emailType, emailTypeSpace) {
        const errors = [];
        let hasWhitespace = false; // Flag to track if any email has whitespace
        if (emailList) {
            emailList.forEach((e) => {
                if (e && this.trailingWhitespace(e)) {
                    hasWhitespace = true; // Set flag to true if whitespace is found
                    // Add a custom error message for emails with trailing whitespaces
                    errors.push('Invalid input. Please make sure that there are no whitespaces before or after the email addresses provided');
                }
            });
        }
        // If no whitespaces were found and there are other errors, push the invalidType error message
        if (!hasWhitespace && this.$v.form[emailType].$anyError) {
            errors.push(invalidType(emailTypeSpace));
        }
        return errors;
    }
    get openingTimeErrors() {
        const errors = [];
        if (!this.$v.openingTime.$dirty) {
            return errors;
        }
        if (!this.$v.openingTime.required) {
            const msg = requiredProperty('Opening Time');
            errors.push(msg);
        }
        return errors;
    }
    get closingTimeErrors() {
        const errors = [];
        if (!this.$v.closingTime.$dirty) {
            return errors;
        }
        if (!this.$v.closingTime.required) {
            const msg = requiredProperty('Closing Time');
            errors.push(msg);
        }
        return errors;
    }
    get leadTimeErrors() {
        const errors = [];
        if (!this.$v.leadTimeDays.$dirty) {
            return errors;
        }
        if (!this.$v.leadTimeDays.required) {
            const msg = requiredProperty('Lead Time');
            errors.push(msg);
        }
        if (!this.$v.leadTimeDays.numeric) {
            const msg = 'Lead Time should be a number';
            errors.push(msg);
        }
        if (!this.$v.leadTimeDays.minValue) {
            const msg = 'Lead Time should be greater than 0';
            errors.push(msg);
        }
        return errors;
    }
    get isMallManagement() {
        return this.$route.params.key === MALL_MANAGEMENT;
    }
    get isB2cBundle() {
        return (this.$route.params.key === Bundle.Ecommerce || this.$props?.serviceBundle === ECOMMERCE_B2C);
    }
    get isShopifyBundle() {
        return this.$route.params.key === Bundle.Shopify || this.$props?.serviceBundle === SHOPIFY;
    }
    get isInsuranceBundle() {
        return this.$route.params.key === Bundle.Insurance;
    }
    cancelledNotifHint(label) {
        if (label.includes('Cancelled')) {
            return `Supports cancel_message tag to be replaced by actual order cancellation message`;
        }
        return null;
    }
    processingFeeLabel() {
        if (this.$route.params.key === Bundle.Insurance) {
            return 'Processing Fee';
        }
        return 'GLife Processing Fee';
    }
    onChange(val, feeType) {
        this.inputConfirmation = true;
        this.feePayload.val = val;
        this.feePayload.feeType = feeType;
    }
    onConfirm() {
        this.inputConfirmation = false;
    }
    onCancel() {
        this.inputConfirmation = false;
        if (this.feePayload.feeType === 'processing') {
            this.form.shoulderProcessingFee = !this.feePayload.val;
        }
        if (this.feePayload.feeType === 'convenience') {
            this.form.shoulderConvenienceFee = !this.feePayload.val;
        }
    }
    async resetPersistentMenu() {
        const self = this;
        this.requestOnFlight();
        await this.$apollo
            .mutate({
            mutation: ResetPersistentMenu,
            variables: {
                input: {
                    appUuid: this.form.appUuid,
                },
            },
        })
            .then(() => {
            const msg = successfulUpdate('Persistent Menu');
            self.successNotification(msg);
            self.clearPersistentErrorNotification();
        })
            .catch((e) => {
            self.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
            self.hideConfirmationDialog();
        });
    }
    async onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            this.$emit('submit', this.form);
            const operatingLeadTimeForm = {
                appUuid: this.form.appUuid,
                enableLeadTime: this.enableLeadTime,
                enableOperatingHours: this.enableOperatingHours,
                leadTimeValue: this.enableLeadTime && this.leadTimeDays ? this.leadTimeDays.toString() : null,
                openingHour: this.openingTime,
                closingHour: this.closingTime,
                allowClosingHoursOrder: this.allowClosingHoursOrder,
            };
            this.$emit('updateOperatingLeadTime', operatingLeadTimeForm);
            this.requestDone();
        }
    }
    mounted() {
        if (this.formData) {
            this.form = { ...this.formData };
            this.form.categoryTree = this.baseCategories();
            if (this.formData.categoryTree) {
                this.formData.categoryTree.forEach((categoryGroup) => {
                    const category = this.form.categoryTree[categoryGroup.primaryCategory];
                    category.primaryOption = true;
                    category.secondaryOptions = [...categoryGroup.secondaryCategories];
                });
                if (!this.diy) {
                    this.$v.form.categoryTree.$touch();
                }
            }
            if (this.form.welcomeMessageContent &&
                this.form.welcomeMessageContent.includes(`${this.serviceBundle} App`) &&
                this.diy) {
                this.form.welcomeMessageContent = this.form.welcomeMessageContent.replace(`${this.serviceBundle} App`, this.fbName);
            }
        }
        const vm = this;
        if (this.operatingHoursData) {
            vm.openingTime = vm.formatTime(vm.operatingHoursData.openingHours);
            vm.closingTime = vm.formatTime(vm.operatingHoursData.closingHours);
            vm.allowClosingHoursOrder = vm.operatingHoursData.allowClosingHoursOrder;
            if (vm.operatingHoursData && vm.operatingHoursData.active) {
                vm.enableOperatingHours = true;
            }
        }
        if (vm.leadTimeData) {
            vm.leadTimeDays = vm.leadTimeData.leadTime;
            if (vm.leadTimeData && vm.leadTimeData.enable) {
                vm.enableLeadTime = true;
            }
        }
    }
};
__decorate([
    Getter('requestOnFlight')
], PageSettingsForm.prototype, "requestCurrentlyOnFlight", void 0);
__decorate([
    Mutation('updatePageGreeting', { namespace: DIY })
], PageSettingsForm.prototype, "updatePageGreeting", void 0);
__decorate([
    Mutation('showConfirmationDialog')
], PageSettingsForm.prototype, "showConfirmationDialog", void 0);
__decorate([
    Mutation('hideConfirmationDialog')
], PageSettingsForm.prototype, "hideConfirmationDialog", void 0);
__decorate([
    Mutation('requestOnFlight')
], PageSettingsForm.prototype, "requestOnFlight", void 0);
__decorate([
    Mutation('requestDone')
], PageSettingsForm.prototype, "requestDone", void 0);
__decorate([
    Prop({ type: Object, default: null })
], PageSettingsForm.prototype, "formData", void 0);
__decorate([
    Prop({ type: Object, default: null })
], PageSettingsForm.prototype, "operatingHoursData", void 0);
__decorate([
    Prop({ type: Object, default: null })
], PageSettingsForm.prototype, "leadTimeData", void 0);
__decorate([
    Prop({ type: String })
], PageSettingsForm.prototype, "plan", void 0);
__decorate([
    Prop({ type: String })
], PageSettingsForm.prototype, "serviceBundle", void 0);
__decorate([
    Prop({ type: String })
], PageSettingsForm.prototype, "fbName", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], PageSettingsForm.prototype, "onSubmitLoading", void 0);
__decorate([
    Watch('form', { deep: true })
], PageSettingsForm.prototype, "onFormChanged", null);
PageSettingsForm = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextArea,
            BaseTextField,
            ButtonGenerator,
            CategoryPicker,
            FormHeader,
            TheDiyActions,
            ConfirmationDialog,
            ToggleConfirmationDialog,
            Uploader,
            BaseImagePlaceholder,
            PhoneInput,
        },
        validations() {
            const vm = this;
            const enableOperatingHours = () => vm.enableOperatingHours && !this.diy;
            const enableLeadTime = () => vm.enableLeadTime && !this.diy;
            const { isInsuranceBundle } = this;
            const validations = {
                form: {
                    appName: {
                        required,
                    },
                    welcomeMessageContent: {
                        required,
                        maxLength: maxLength(500),
                    },
                    welcomeButtonTitle: {
                        required,
                        maxLength: maxLength(20),
                    },
                    greeting: {
                        required,
                        maxLength: maxLength(160),
                    },
                    categoryTree: {
                        required() {
                            if (isInsuranceBundle) {
                                return true;
                            }
                            const { categoryTree } = this.form;
                            const keys = Object.keys(categoryTree);
                            return keys.filter((key) => categoryTree[key].primaryOption === true).length > 0;
                        },
                    },
                    businessDescription: {
                        required: () => {
                            if (this.isInsuranceBundle) {
                                return true;
                            }
                            return !isEmpty(this.form?.businessDescription?.trim());
                        },
                        maxLength: maxLength(800),
                    },
                    emailNotifRecipients: {
                        $each: {
                            email,
                        },
                        required,
                    },
                    supportEmailList: {
                        $each: {
                            email,
                        },
                        required,
                    },
                    supportContactNumber: {},
                    // TODO: clarify validation for store title if automatically set default
                    //       title
                    storeTitle: {},
                },
                openingTime: {
                    required: requiredIf(enableOperatingHours),
                },
                closingTime: {
                    required: requiredIf(enableOperatingHours),
                },
                leadTimeDays: {
                    required: requiredIf(enableLeadTime),
                    numeric,
                    minValue: minValue(1),
                },
                allowClosingHoursOrder: {
                    required: requiredIf(enableOperatingHours),
                },
            };
            return validations;
        },
    })
], PageSettingsForm);
export default PageSettingsForm;
